import { IconProps } from "./Icons";

export const IconPencil = ({
  width = 16,
  height = 16,
  color = "#fff",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.794 13.5H3a.5.5 0 0 1-.5-.5v-2.794a.494.494 0 0 1 .144-.35l7.5-7.5a.5.5 0 0 1 .712 0l2.788 2.788a.5.5 0 0 1 0 .712l-7.5 7.5a.494.494 0 0 1-.35.144v0ZM8.5 4 12 7.5"
    />
  </svg>
);
